import React, { useMemo } from "react";
import { useSearchParams } from "react-router-dom";
import { Container, Box, Alert } from "@mui/material";
import PreferencesPanel from "../components/researcher/PreferencesPanel";

const PreferencesPage: React.FC = () => {
  const [searchParams] = useSearchParams();
  const studyId = useMemo(() => searchParams.get("study"), [searchParams]);

  if (!studyId) {
    return (
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Alert severity="error">
          Study ID is required. Please open this page from your dashboard.
        </Alert>
      </Container>
    );
  }

  return (
    <Box sx={{ bgcolor: "#f5f5f5", minHeight: "100vh", py: 2 }}>
      <Container maxWidth="lg">
        <PreferencesPanel studyId={studyId} onClose={() => window.close()} />
      </Container>
    </Box>
  );
};

export default PreferencesPage;
